import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=70572e38&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=70572e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70572e38",
  null
  
)

export default component.exports